<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> {{label.selectionCriteria}}
                </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="form.tranDateFrom" :label="label.tranDateFrom" :data-vv-as="label.tranDateFrom" data-vv-name="form.tranDateFrom"
                            :error-messages="errors.collect('form.tranDateFrom')" v-validate="doValidateTranDateFrom" :max="new Date()"/>
                        </v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="form.tranDateTo" :label="label.tranDateTo" :data-vv-as="label.tranDateTo" data-vv-name="form.tranDateTo"
                            :error-messages="errors.collect('form.tranDateTo')" v-validate="doValidateTranDateTo" :max="new Date()"/>
                        </v-flex>

                        <v-flex xs12 md6 lg6>
                          <v-checkbox color="primary" :label="label.chkTtyPeriod" v-model="form.chkTtyPeriod"></v-checkbox>
                        </v-flex>

                        <v-flex xs12 md6 lg6>
                          <v-autocomplete :items="reportByList" v-model="form.reportBy" :label="label.reportBy" item-text="label" item-value="value" data-vv-name="form.reportBy" :data-vv-as="label.reportBy" :error-messages="errors.collect('form.reportBy')" :disabled="!form.chkTtyPeriod"></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel2" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> {{label.filters}}
                </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 md6 lg6>
                          <v-autocomplete :items="driList" v-model="form.dri" :label="label.dri" item-text="label" item-value="value" data-vv-name="form.dri" :data-vv-as="label.dri" :error-messages="errors.collect('form.dri')"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 lg6>
                          <v-text-field v-model="form.branch" :label="label.branch" :error-messages="errors.collect('branch')" data-vv-name="branch" :data-vv-as="label.branch"
                                append-icon="mdi-magnify" readonly @click:append="showBranchHelpList = true"/>
                        </v-flex>

                        <v-flex xs12 md6 lg6>
                          <v-text-field v-model="form.riType" :label="label.riType" :error-messages="errors.collect('riType')" data-vv-name="riType" :data-vv-as="label.riType"
                                append-icon="mdi-magnify" readonly @click:append="showRiTypeHelpList = true"/>
                        </v-flex>

                        <v-flex xs12 md12 lg12>
                          <v-text-field v-model="form.riCo" :label="label.riCo" :error-messages="errors.collect('riCo')" data-vv-name="riCo" :data-vv-as="label.riCo"
                                append-icon="mdi-magnify" readonly @click:append="showRiCoHelpList = true" :disabled="this.disableRiCo"/>
                        </v-flex>

                        <v-flex xs12 md12 lg12>
                          <v-text-field v-model="form.ttyRefNo" :label="label.ttyRefNo" :error-messages="errors.collect('ttyRefNo')" data-vv-name="ttyRefNo" :data-vv-as="label.ttyRefNo"
                                append-icon="mdi-magnify" readonly @click:append="showTtyRefNoHelpList = true" :disabled="this.disableTtyRefNo"/>
                        </v-flex>

                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            :label="label.pbPrtParam"
            v-model="form.pbPrtParam"
            :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam"
            :data-vv-as="label.pbPrtParam"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{label.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="showBranchHelpList = false" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
    </v-dialog>

    <v-dialog v-model="showRiTypeHelpList" width="900px" persistent>
      <multi-ri-type-help-list :riType="form.riType" @close="showRiTypeHelpList = false" @doAssign="doAssignRiType($event)"></multi-ri-type-help-list>
    </v-dialog>

    <v-dialog v-model="showRiCoHelpList" width="900px" persistent>
      <multi-intermediary-help-list
        :intr="form.riCo"
        intrGrp="20"
        helpListTitle="RI Company Code Helplist"
        @close="showRiCoHelpList = false" @doAssign="doAssignInter($event)"></multi-intermediary-help-list>
    </v-dialog>

    <v-dialog v-model="showTtyRefNoHelpList" width="900px" persistent>
      <multi-treaty-ref-no-help-list v-if="showTtyRefNoHelpList" :ttyrefno="form.ttyRefNo" :ritype="form.riType" @close="showTtyRefNoHelpList = false" @doAssign="doAssignTtyRefNo($event)"></multi-treaty-ref-no-help-list>
    </v-dialog>

    <v-dialog v-model="processingFlag" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { reportByList, driList, riTypeList } from './index'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList2.vue'
import MultiRiTypeHelpList from '@/components/core/common/dialog/MultiRiTypeHelpList.vue'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
import MultiTreatyRefNoHelpList from '@/components/core/common/dialog/MultiTreatyRefNoHelpList.vue'

export default {
  data() {
    return {
      form: {
        tranDateFrom: null,
        tranDateTo: null,
        chkTtyPeriod: false,
        reportBy: 'UY',
        dri: 'B',
        branch: 'All',
        riType: 'All',
        riCo: 'All',
        ttyRefNo: 'All',
        format: undefined,
        pbPrtParam: true
      },
      label: {
        selectionCriteria: 'Selection Criteria',
        filters: 'Filters',
        reportBy: 'Report By',
        chkTtyPeriod: 'Check Treaty Period',
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'Transaction Date To',
        dri: 'Direct/RI',
        branch: 'Branch(es)',
        riType: 'RI Type(s)',
        riCo: 'RI Company Code(s)',
        ttyRefNo: 'Treaty Reference No(s)',
        format: 'Export Format',
        export: 'Export to',
        pbPrtParam: 'Print Runtime Parameters'
      },
      menu: {},
      supportedFormat: [],
      loading: false,
      reportByList: [],
      driList: [],
      branchList: [],
      riTypeList: [],
      processingFlag: false,
      showBranchHelpList: false,
      showRiTypeHelpList: false,
      showRiCoHelpList: false,
      showTtyRefNoHelpList: false,
      disableRiCo: false,
      disableTtyRefNo: false,
      panel1: [0],
      panel2: [0]
    }
  },
  methods: {
    async doInit() {
      this.form.tranDateTo = new Date()
      try {
        if (this.$store.state.reports.riReports.init !== 1) {
          await Promise.all([this.$store.dispatch('riReportsInit')])
        }
        const apiURI = this.$store.state.reports.riReports.menu.outPremComm
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.exportOutPremCommRpt()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async exportOutPremCommRpt() {
      const apiURI = this.menu.exportOutPremCommRpt
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doAssignBranch(Obj) {
      this.form.branch = []
      this.form.branch = Obj.finalSelectedItems.toString()
    },
    doAssignRiType(Obj) {
      this.form.riType = []
      this.form.riType = Obj.finalSelectedItems.toString()
      this.doCheckRiType()
    },
    doAssignInter(Obj) {
      this.form.riCo = []
      this.form.riCo = Obj.finalSelectedItems.toString()
    },
    doAssignTtyRefNo(Obj) {
      this.form.ttyRefNo = []
      this.form.ttyRefNo = Obj.finalSelectedItems.toString()
    },
    doCheckRiType() {
      var ritype = this.form.riType.split(',')

      if (ritype.includes('T') || ritype.includes('W') ||
      ritype.includes('All')) {
        this.disableTtyRefNo = false
      } else {
        this.disableTtyRefNo = true
      }

      if (ritype.includes('C') || ritype.includes('F') ||
      ritype.includes('All')) {
        this.disableRiCo = false
      } else {
        this.disableRiCo = true
      }
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    doValidateTranDateFrom() {
      const today = new Date()
      return 'required|valMaxDate:' + today
    },
    doValidateTranDateTo() {
      if (this.form.tranDateFrom !== null) {
        return 'required|valMinDate:' + this.form.tranDateFrom
      } else {
        return 'required'
      }
    }
  },
  created() {
    this.doInit()
    this.reportByList = reportByList
    this.driList = driList
    this.riTypeList = riTypeList

    this.$validator.extend('valMaxDate', {
      getMessage(field, args) {
        return 'Cannot be later than System Date'
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinDate', {
      getMessage(field, args) {
        return 'Cannot be earlier than From Date'
      },
      validate(value, args) {
        let mixDate = args[0]
        if (value) {
          return !isAfter(removeTime(mixDate), removeTime(value))
        } else return true
      }
    })
  },
  watch: {
    'disableRiCo': function (value) {
      if (value) {
        this.form.riCo = 'All'
      }
    },
    'disableTtyRefNo': function (value) {
      if (value) {
        this.form.ttyRefNo = 'All'
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    MultiBranchHelpList,
    MultiRiTypeHelpList,
    MultiIntermediaryHelpList,
    MultiTreatyRefNoHelpList
  }
}

</script>
